import React, { useState, useEffect } from 'react';
import Accordion from '@sabre/spark-react-core/accordion';
import { Drawer } from '@sabre/spark-react-core/accordion/drawer';
import Button from '@sabre/spark-react-core/button';
import Checkbox from '@sabre/spark-react-core/checkbox';
import DateInputWithPicker from '@sabre/spark-react-core/date-selection/date-input-with-picker';
import SelectInput from '@sabre/spark-react-core/select-input';
import TextInput from '@sabre/spark-react-core/text-input';
import Tooltip from '@sabre/spark-react-core/tooltip';
import { array, bool, func, string } from 'prop-types';
import { createUniqueId } from '../../../utils/common-util.js';
import {
   CRITERIA_HEADER_DETAILS,
   OPERATOR_OPTIONS,
   DISTRIBUTION_OPERATOR_OPTIONS,
   SEARCH_CRITERIA_CONFIG,
   SEARCH_CRITERIA_FOOTER_CONFIG,
   monthNames,
   FIELDS_TO_EXCLUDE_FROM_DATE_PICKER,
   FIELDS_WITH_ONE_CHARACTER_LIMIT,
   FIELDS_WITH_TWO_CHARACTER_LIMIT,
   FIELDS_WITH_THREE_CHARACTER_LIMIT,
   FIELDS_WITH_FOUR_CHARACTER_LIMIT,
   FIELDS_WITH_FIVE_CHARACTER_LIMIT,
   FIELDS_WITH_SIX_CHARACTER_LIMIT,
   FIELDS_WITH_SEVEN_CHARACTER_LIMIT,
   FIELDS_WITH_EIGHT_CHARACTER_LIMIT,
   FIELDS_WITH_TEN_CHARACTER_LIMIT,
   FIELDS_WITH_FIFTEEN_CHARACTER_LIMIT,
   FIELDS_WITH_TWENTY_CHARACTER_LIMIT,
   FIELD_WITH_ELEVEN_CHARACTER_LIMIT,
   APP_TITLE,
   AMOUNT_FIELDS,
   NUMERIC_FIELDS,
   ALPHA_ONLY_FIELDS,
   ALPHA_NUMERIC_FIELDS,
   ALPHA_NUMERIC_FIELDS_WITH_STAR,
   DATE_STRING_FIELDS,
   NON_ACCORDION_CATEGORY,
   ALLOW_PIPE_SYMBOL_FIELD,
   SPECIAL_CHAR_FIELDS,
   ALPHA_NUMERIC_FIELDS_WITH_ATPCO_WILD_CARDS,
   ALPHA_NUMERIC_FIELD_WITH_HYPHEN,
   SCREEN_NAMES,
} from '../../../utils/constants.js';
import { DateUtil } from '../../../utils/date-util.js';
import MultiSelect from '../../multi-select/multi-select.jsx';
import RadioButtons from '../../radio-buttons/radio-buttons.jsx';

const SearchCriteria = ({
   getSearchCriteria,
   updateTariffNumber,
   showWarning,
   isTariffNumberAvailable,
   data,
   handleSearchCriteriaSearch,
   handleStopSearchRequest,
   currentScreen,
   handleReferenceGroupChange = () => {},
   reRunQuery = null,
}) => {
   const [searchCriteriaConfig, setSearchCriteriaConfig] = useState(
      SEARCH_CRITERIA_CONFIG
   );
   const operator = ['Fares', 'Footnotes', 'Rules'].includes(currentScreen)
      ? OPERATOR_OPTIONS
      : DISTRIBUTION_OPERATOR_OPTIONS;

   const [activeDrawerIds, setActiveDrawerIds] = useState([]);
   const [searchCriteriaFooterConfiguration] = useState(
      SEARCH_CRITERIA_FOOTER_CONFIG
   );
   const [key, setKey] = useState(createUniqueId());
   const defaultDistributionScreenSelectedCategory =
      'Distribution Group Management';
   const [selectedDistributionCategory, setSelectedDistributionCategory] =
      useState(defaultDistributionScreenSelectedCategory);

   const renderValues = (value, type, item) => {
      switch (type) {
         case 'Checkbox':
            return (item.value = !item.value);
         case 'DropDown':
            return (item.operator = value);
         case 'DropDownText':
            return (item.values = value.toUpperCase().split(','));
         case 'DropDownDate':
            if (!FIELDS_TO_EXCLUDE_FROM_DATE_PICKER.includes(item.keyCode))
               return (item.values = DateUtil.validate(value)
                  ? DateUtil.formatDate(value, DateUtil.DATE_FORMATS.DD_MM_YYYY)
                       .toString()
                       .toUpperCase()
                       .split(',')
                  : value);
            else return (item.values = value.toUpperCase().split(','));
         case 'UserInput':
            return (item.values = DateUtil.formatDate(
               value,
               DateUtil.DATE_FORMATS.DD_MMM_YY
            )
               .toString()
               .split(','));
      }
   };
   const validation = (value, selectedDetails) => {
      const collection = value.split(',');
      let limitOverFlowDetails = {
         isLimitOverFlow: false,
         message: '',
      };
      if (collection.length > 0)
         collection.map((list) => {
            if (list.length) {
               if (
                  (FIELDS_WITH_ONE_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 1) ||
                  (FIELDS_WITH_TWO_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 2) ||
                  (FIELDS_WITH_THREE_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 3) ||
                  (FIELDS_WITH_FOUR_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 4) ||
                  (FIELDS_WITH_FIVE_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 5) ||
                  (FIELDS_WITH_SIX_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 6) ||
                  (FIELDS_WITH_SEVEN_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 7) ||
                  (FIELDS_WITH_EIGHT_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 8) ||
                  (FIELD_WITH_ELEVEN_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 11) ||
                  (FIELDS_WITH_TEN_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 10) ||
                  (FIELDS_WITH_FIFTEEN_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 15) ||
                  (FIELDS_WITH_TWENTY_CHARACTER_LIMIT.includes(
                     selectedDetails.keyCode
                  ) &&
                     list.length > 20) ||
                  (APP_TITLE.includes(selectedDetails.keyCode) &&
                     list.length > 126)
               ) {
                  limitOverFlowDetails.isLimitOverFlow = true;
                  limitOverFlowDetails.message = `Maximum ${
                     list.length - 1
                  } characters allowed in ${selectedDetails.keyCode} (${
                     selectedDetails.title
                  }) field!`;
               }
            }
         });
      return limitOverFlowDetails;
   };
   const handleUpdateSearchCriteriaConfig = (
      value,
      selectedDetails,
      categoryName,
      type,
      elementType
   ) => {
      if (elementType) {
         const limitOverFlowDetails = validation(value, selectedDetails);
         if (limitOverFlowDetails.isLimitOverFlow) {
            showWarning(limitOverFlowDetails.message);
            return;
         }
      }
      let updatedSearchCriteriaConfig = searchCriteriaConfig.map(
         (searchCriteriaItems) => {
            searchCriteriaItems.categoryName === categoryName &&
               searchCriteriaItems.categoryDetails.map((item) => {
                  if (item.keyCode === selectedDetails.keyCode)
                     renderValues(value, type, item);
                  if (
                     item.keyCode === 'TAR' &&
                     selectedDetails.keyCode === 'TAR'
                  ) {
                     updateTariffNumber?.(value ? true : false);
                  }
               });
            return searchCriteriaItems;
         }
      );
      setSearchCriteriaConfig(updatedSearchCriteriaConfig);
      getSearchCriteria(updatedSearchCriteriaConfig, 'default');
   };

   const handleRadioButtonChange = (
      key,
      currentCategoryName,
      currentScreen
   ) => {
      const sectionToUpdate = searchCriteriaConfig.find(
         (section) =>
            section.categoryName === currentCategoryName &&
            section.screen.includes(currentScreen)
      );

      const updatedRadioButtonData = sectionToUpdate?.categoryDetails?.map(
         (radioButtonData) => {
            return {
               ...radioButtonData,
               value: radioButtonData.key === key ? true : false,
            };
         }
      );

      const updatedSectionData = {
         ...sectionToUpdate,
         categoryDetails: updatedRadioButtonData,
      };

      const updatedSearchCriteriaConfig = searchCriteriaConfig.map(
         (existingSectionData) => {
            const isCurrentSection =
               existingSectionData.categoryName === currentCategoryName &&
               existingSectionData.screen.includes(currentScreen);
            return isCurrentSection ? updatedSectionData : existingSectionData;
         }
      );

      setSearchCriteriaConfig(updatedSearchCriteriaConfig);
      getSearchCriteria(updatedSearchCriteriaConfig, 'default');
   };

   const handleSearchCriteriaFooterEventsClick = (value) => {
      if (value === 'CLEAR') {
         let updatedSearchCriteriaConfig = searchCriteriaConfig.map(
            (searchCriteriaItems) => {
               searchCriteriaItems.categoryDetails.map((item) => {
                  if (
                     searchCriteriaItems.type === 'Checkbox' ||
                     searchCriteriaItems.type === 'RadioButtons'
                  )
                     item.value = false;
                  else if (searchCriteriaItems.type === 'DropDownText') {
                     item.values = '';
                     item.operator = operator[0].value;
                  } else if (searchCriteriaItems.type === 'DropDownDate') {
                     if (
                        !FIELDS_TO_EXCLUDE_FROM_DATE_PICKER.includes(
                           item.keyCode
                        )
                     )
                        item.values = '';
                     else item.values = '';
                     item.operator = operator[0].value;
                  }
               });
               return searchCriteriaItems;
            }
         );
         setSearchCriteriaConfig(updatedSearchCriteriaConfig);
         getSearchCriteria(updatedSearchCriteriaConfig, 'clear');
         setKey(createUniqueId());
      } else if (value === 'SEARCH') {
         handleSearchCriteriaSearch(searchCriteriaConfig);
      } else {
         handleStopSearchRequest();
      }
   };

   const getRadioButtonData = (radioButtonConfig) => {
      const radioButtonData = radioButtonConfig?.map(({ key }) => {
         return {
            label: key,
            value: key,
         };
      });

      return radioButtonData || [];
   };

   const getSelectedRadioButtonValue = (radioButtonData) => {
      const selectedRadioButton = radioButtonData?.find(({ value }) => !!value);

      return selectedRadioButton?.key || null;
   };

   const getFilteredSearchCriteriaConfig = (categoryName) => {
      const MarketListFields = ['Market List', 'Table'];
      const DistributionGroupManagementFields = [
         'Distribution Groups',
         'Table',
      ];

      const referenceCategoriesFilteredSearchCriteria =
         SEARCH_CRITERIA_CONFIG.filter((category) => {
            if (category.screen.includes('Distribution')) {
               if (
                  categoryName == 'Distribution Group Management' &&
                  !DistributionGroupManagementFields.includes(
                     category.categoryName
                  )
               )
                  return false;
               else if (
                  categoryName === 'Market List' &&
                  !MarketListFields.includes(category.categoryName)
               )
                  return false;
            }

            return true;
         });

      const updatedSearchCriteriaConfig =
         referenceCategoriesFilteredSearchCriteria.map((category) => {
            const shouldResetValues =
            category.categoryName === SCREEN_NAMES.MARKET_LIST ||
            category.categoryName === SCREEN_NAMES.DISTRIBUTION_GROUP;

         const resetCategoryDetails = shouldResetValues
            ? category.categoryDetails.map((detail) => ({
                 ...detail,
                 values: '',
              }))
            : category.categoryDetails;

            return category.categoryName === 'Table'
               ? { ...category, value: categoryName }
               : {
                  ...category,
                  categoryDetails: resetCategoryDetails,
               };
         });

      return updatedSearchCriteriaConfig;
   };

   useEffect(() => {
      let updatedSearchCriteriaConfig = searchCriteriaConfig.map(
         (searchCriteriaItems) => {
            searchCriteriaItems.type !== 'Checkbox' &&
               searchCriteriaItems.type !== 'DropDownGlobalItem' &&
               searchCriteriaItems.type !== 'RadioButtons' &&
               searchCriteriaItems.categoryDetails.map((item) => {
                  item.title = CRITERIA_HEADER_DETAILS.find(
                     (list) => list.KEY === item.keyCode.toLocaleLowerCase()
                  )?.VALUE;
                  item.operator = operator[0].value;
                  return item;
               });
            return searchCriteriaItems;
         }
      );
      setSearchCriteriaConfig(updatedSearchCriteriaConfig);
      getSearchCriteria(updatedSearchCriteriaConfig, 'default');
      return () => {
         handleSearchCriteriaFooterEventsClick('CLEAR');
      };
   }, []);
   useEffect(() => {
      if (data && data.length > 0) {
         setSearchCriteriaConfig(data);
      }
   }, [data]);
   useEffect(() => {
      if (currentScreen === 'Rules') {
         const expandedAccordionCategories = [];
         searchCriteriaConfig.forEach((list, index) => {
            if (
               list.categoryDetails.some(
                  (subList) =>
                     subList?.values?.length > 0 &&
                     !NON_ACCORDION_CATEGORY.includes(list.categoryName)
               )
            )
               expandedAccordionCategories.push(`drawer-${index}`);
         });
         setActiveDrawerIds(expandedAccordionCategories);
      }
   }, [getSearchCriteria]);
   const handleKeyPress = (event, code) => {
      if (
         (!/[0-9\s%_,]/.test(event.key) &&
            (code === 'RTG' || code === 'MAX ST')) ||
         (NUMERIC_FIELDS.includes(code) && !/^[0-9\s%_,]+$/.test(event.key)) ||
         (!/^[\d.\d\s%_]*$/.test(event.key) && AMOUNT_FIELDS.includes(code)) ||
         (!/^[a-zA-Z0-9\s%_|,]+$/.test(event.key) && code === 'DOW') ||
         (!/^[a-zA-Z0-9-%_,]+$/.test(event.key) && code === 'MIN ST') ||
         (!/^[a-zA-Z\s%_,]+$/.test(event.key) &&
            ALPHA_ONLY_FIELDS.includes(code)) ||
         (!/^[a-zA-Z0-9\s%_,]+$/.test(event.key) &&
            ALPHA_NUMERIC_FIELDS.includes(code)) ||
         (!/^[a-zA-Z0-9\s%_,-]+$/.test(event.key) &&
            ALPHA_NUMERIC_FIELD_WITH_HYPHEN.includes(code)) ||
         (!/^[a-zA-Z0-9\s%_*,]+$/.test(event.key) &&
            ALPHA_NUMERIC_FIELDS_WITH_STAR.includes(code)) ||
         (!/^[a-zA-Z0-9\s%_:,]+$/.test(event.key) &&
            DATE_STRING_FIELDS.includes(code)) ||
         (!/^[a-zA-Z0-9\s%_|,-]+$/.test(event.key) &&
            ALLOW_PIPE_SYMBOL_FIELD.includes(code)) ||
         (!/^[=:&/*%_,]+$/.test(event.key) &&
            SPECIAL_CHAR_FIELDS.includes(code)) ||
         (!/^[a-zA-Z0-9\s%_,!&-]+$/.test(event.key) &&
            ALPHA_NUMERIC_FIELDS_WITH_ATPCO_WILD_CARDS.includes(code)) ||
         (!/^[a-zA-Z0-9\s%_,]+$/.test(event.key) &&
            ALPHA_NUMERIC_WITHOUT_SPACES_FIELDS.includes(code))
      )
         event.preventDefault();
   };

   const handleFocus = (event) => event.target.select();

   const handleSelectChange = (_, value) => {
      setSearchCriteriaConfig(getFilteredSearchCriteriaConfig(value));
      setSelectedDistributionCategory(value);
      const selectedScreen = value === 'Distribution Group Management'
      ? SCREEN_NAMES.DISTRIBUTION_GROUP
      : value;
      handleReferenceGroupChange(selectedScreen);
   };

   const getDropdownDisabledStatus = (categoryName, keyCode) => {
      const disabledCategories = ['Brand'];
      const disabledFields = [
         'FTNT',
         'ADDON',
         'FARES',
         'S',
         'DIST GRP',
         'CHG USER',
         'CHG DT',
         'LAST UPDATED',
         'MKT',
         'SRC',
         'TIER',
         'MKT GRP',
         'MKT TYP',
         'MKT AST',
         'MKT CAT',
      ];

      return (
         disabledCategories.includes(categoryName) ||
         disabledFields.includes(keyCode)
      );
   };

   useEffect(() => {
      if (currentScreen === 'Distribution') {
         const updatedSearchCriteriaConfig = getFilteredSearchCriteriaConfig(
            defaultDistributionScreenSelectedCategory
         );
         getSearchCriteria(updatedSearchCriteriaConfig, 'default');
         return;
      }
   }, [currentScreen]);

   useEffect(() => {
      if (reRunQuery) {
         handleSearchCriteriaSearch(searchCriteriaConfig, true);
      }
   }, [reRunQuery]);

   const renderSearchCriteriaFields = (searchCriteriaItems) => {
      return (
         <div className='row search-criteria-border-bottom spark-pad-l-.5 spark-pad-r-.5'>
            {(searchCriteriaItems.type === 'Checkbox' ||
               searchCriteriaItems.type === 'DropDownGlobalItem') &&
            searchCriteriaItems.screen.includes(currentScreen) ? (
               searchCriteriaItems.categoryDetails.map((itemDetails) => {
                  return (
                     <div
                        className={`${
                           searchCriteriaItems.categoryName === 'Products'
                              ? 'col-md-3 col-lg-3'
                              : searchCriteriaItems.screen.includes('Fares') &&
                                'col-md-4 col-lg-4'
                        } ${
                           searchCriteriaItems.screen.includes(
                              'Distribution'
                           ) && 'col-md-12 col-lg-12'
                        }
        spark-flex spark-pad-0`}
                        key={`${itemDetails.key} +${searchCriteriaItems.categoryName}`}
                     >
                        <span className='search-criteria-check-box-label spark-pad-r-1 check-box-font'>
                           <Tooltip
                              anchorY='top'
                              anchorX='center'
                              toggleEl={
                                 <div
                                    className='spark-bold default-font-family'
                                    data-testid={`${itemDetails.key}-id`}
                                 >
                                    {itemDetails.key}
                                 </div>
                              }
                           >
                              {itemDetails.key}
                           </Tooltip>
                        </span>

                        {['Footnotes', 'Fares'].includes(
                           searchCriteriaItems.screen
                        ) ? (
                           <Checkbox
                              className={`${
                                 itemDetails.value === true ? 'spark-info' : ''
                              }`}
                              data-testid={`${itemDetails.key}-checkbox-id`}
                              value={itemDetails.key}
                              checked={itemDetails.value}
                              disabled={true}
                              onChange={() =>
                                 handleUpdateSearchCriteriaConfig(
                                    undefined,
                                    itemDetails,
                                    searchCriteriaItems.categoryName,
                                    searchCriteriaItems.type
                                 )
                              }
                           />
                        ) : (
                           <SelectInput
                              options={itemDetails.categoryDetails}
                              label={`'stored-criteria-dropdown'${itemDetails.key}`}
                              data-testid={`${itemDetails.key}-drop-down`}
                              name={`${itemDetails.key}-drop-down`}
                              tabIndex='-1'
                              value={selectedDistributionCategory}
                              onChange={handleSelectChange}
                           />
                        )}
                     </div>
                  );
               })
            ) : searchCriteriaItems.type === 'DropDownText' &&
              searchCriteriaItems.screen.includes(currentScreen) ? (
               searchCriteriaItems.categoryDetails.map(
                  (itemDetails, subIndex) => {
                     return (
                        itemDetails.keyCode !== 'TIMESTAMP' &&
                        itemDetails.keyCode !== 'USER' &&
                        itemDetails.keyCode !== 'ACTION' &&
                        itemDetails.keyCode !== 'NOTES' && (
                           <div
                              className='col-md-6 col-lg-6 spark-flex spark-pad-0'
                              key={`${subIndex}${itemDetails.keyCode}`}
                           >
                              <div className='row spark-pad-l-.5'>
                                 <div className='col-md-5 col-lg-5 col-sm-5 spark-pad-0'>
                                    <strong
                                       className={`default-font-family w-full ${
                                          (subIndex + 1) % 2 === 0
                                             ? 'search-criteria-label'
                                             : 'spark-pad-0'
                                       } spark-pad-r-.5`}
                                    >
                                       <Tooltip
                                          anchorY='top'
                                          anchorX='center'
                                          toggleEl={
                                             <div
                                                className='field-label-truncation'
                                                data-testid={`${itemDetails.keyCode}-label-id`}
                                             >
                                                {itemDetails.keyCode}
                                             </div>
                                          }
                                       >
                                          <div className='default-font-family'>
                                             {itemDetails.title}
                                          </div>
                                       </Tooltip>
                                    </strong>
                                 </div>

                                 {itemDetails.keyCode !== 'CAT NM' ? (
                                    <div className='col-md-7 col-lg-7 col-sm-7 spark-pad-0 spark-flex'>
                                       <SelectInput
                                          className={`${
                                             subIndex >= 2
                                                ? 'empty-border-top'
                                                : ''
                                          }`}
                                          style={{
                                             width: '40px',
                                          }}
                                          key={`stored-criteria-key ${itemDetails.operator}`}
                                          name={`${itemDetails.keyCode}-drop-down`}
                                          data-testid={`${itemDetails.keyCode}-drop-down`}
                                          label={`'stored-criteria-dropdown'${itemDetails.keyCode}`}
                                          options={operator}
                                          tabIndex='-1'
                                          value={itemDetails.operator}
                                          disabled={getDropdownDisabledStatus(
                                             searchCriteriaItems.categoryName,
                                             itemDetails.keyCode
                                          )}
                                          onChange={(event) =>
                                             handleUpdateSearchCriteriaConfig(
                                                event.target.value,
                                                itemDetails,
                                                searchCriteriaItems.categoryName,
                                                'DropDown'
                                             )
                                          }
                                       />
                                       <div className='spark-pad-0 w-full'>
                                          <TextInput
                                             className={`input-text ${
                                                subIndex >= 2
                                                   ? 'empty-border-top'
                                                   : ''
                                             }   ${
                                                itemDetails.values.toString()
                                                   .length > 0
                                                   ? itemDetails.values.toString()
                                                      ? searchCriteriaItems.categoryName ===
                                                        'Identifier'
                                                         ? 'identifier-color'
                                                         : searchCriteriaItems.categoryName ===
                                                           'Fare Value'
                                                         ? 'fare-value-color'
                                                         : searchCriteriaItems.categoryName ===
                                                           'Fare Class'
                                                         ? 'fare-class-color'
                                                         : searchCriteriaItems.categoryName ===
                                                           'Footnote'
                                                         ? 'footnote-color'
                                                         : searchCriteriaItems.categoryName ===
                                                           'Rule'
                                                         ? 'rule-color'
                                                         : searchCriteriaItems.categoryName ===
                                                           'Market'
                                                         ? 'market-color'
                                                         : searchCriteriaItems.categoryName ===
                                                           'Brand'
                                                         ? 'brand-color'
                                                         : searchCriteriaItems.categoryName ===
                                                           'Distribution'
                                                         ? 'distribution-color'
                                                         : searchCriteriaItems.categoryName ===
                                                           'Distribution Groups'
                                                         ? 'distribution-group-color'
                                                         : ''
                                                      : ''
                                                   : ''
                                             }`}
                                             data-testid={`${itemDetails.keyCode}-drop-down-text`}
                                             name={itemDetails.keyCode}
                                             autocomplete='off'
                                             onFocus={(event) =>
                                                handleFocus(event)
                                             }
                                             disabled={getDropdownDisabledStatus(
                                                searchCriteriaItems.categoryName,
                                                itemDetails.keyCode
                                             )}
                                             value={itemDetails.values
                                                .toString()
                                                .toUpperCase()}
                                             onKeyPress={(event) =>
                                                handleKeyPress(
                                                   event,
                                                   itemDetails.keyCode
                                                )
                                             }
                                             onChange={(event) =>
                                                handleUpdateSearchCriteriaConfig(
                                                   event.target.value,
                                                   itemDetails,
                                                   searchCriteriaItems.categoryName,
                                                   searchCriteriaItems.type,
                                                   'input',
                                                   event
                                                )
                                             }
                                          />
                                       </div>
                                    </div>
                                 ) : (
                                    <div className='col-md-7 col-lg-7 col-sm-7 spark-pad-0'>
                                       <MultiSelect
                                          options={itemDetails.categoryDetails}
                                          data-testid={`${itemDetails.key}-drop-down`}
                                          name={`${itemDetails.key}-drop-down`}
                                          selectedValues={
                                             itemDetails.values || []
                                          }
                                          multiSelectOnChangeHandler={(
                                             values
                                          ) => {
                                             handleUpdateSearchCriteriaConfig(
                                                values
                                                   .map(({ value }) => value)
                                                   .join(','),
                                                itemDetails,
                                                searchCriteriaItems.categoryName,
                                                searchCriteriaItems.type
                                             );
                                          }}
                                          placeHolder=''
                                          className='multi-select-input'
                                          showLabel={false}
                                          enableSelectAll={false}
                                       />
                                    </div>
                                 )}
                              </div>
                           </div>
                        )
                     );
                  }
               )
            ) : searchCriteriaItems.type === 'DropDownDate' &&
              searchCriteriaItems.screen.includes(currentScreen) ? (
               searchCriteriaItems.categoryDetails.map(
                  (itemDetails, subIndex) => {
                     return (
                        itemDetails.keyCode !== 'UAC' && (
                           <div
                              className='col-md-6 col-lg-6 spark-pad-0'
                              key={subIndex}
                           >
                              <div className='row spark-pad-l-.5'>
                                 <div className='col-md-5 col-lg-5 col-sm-5 spark-pad-0'>
                                    <strong
                                       className={`default-font-family ${
                                          (subIndex + 1) % 2 === 0
                                             ? 'search-criteria-label'
                                             : 'spark-pad-0'
                                       }`}
                                    >
                                       <Tooltip
                                          anchorY='top'
                                          anchorX='center'
                                          toggleEl={
                                             <div
                                                data-testid={`${itemDetails.keyCode}-label-id`}
                                             >
                                                {itemDetails.keyCode}
                                             </div>
                                          }
                                       >
                                          {itemDetails.title}
                                       </Tooltip>
                                    </strong>
                                 </div>

                                 <div className='col-md-7 col-lg-7 col-sm-7 spark-pad-0 spark-flex'>
                                    <SelectInput
                                       className={`${
                                          subIndex >= 2
                                             ? 'empty-border-top'
                                             : ''
                                       }`}
                                       style={{
                                          width: '40px',
                                       }}
                                       key={`stored-criteria-key ${itemDetails.operator}`}
                                       label={`'stored-criteria-dropdown'${itemDetails.keyCode}`}
                                       name={`'stored-criteria-dropdown'${itemDetails.keyCode}`}
                                       options={operator}
                                       tabIndex='-1'
                                       value={itemDetails.operator}
                                       onChange={(event) =>
                                          handleUpdateSearchCriteriaConfig(
                                             event.target.value,
                                             itemDetails,
                                             searchCriteriaItems.categoryName,
                                             'DropDown'
                                          )
                                       }
                                    />

                                    <div
                                       className={`${
                                          searchCriteriaItems.categoryDetails
                                             .length %
                                             2 !==
                                             0 &&
                                          subIndex ===
                                             searchCriteriaItems.categoryDetails
                                                .length -
                                                1
                                             ? 'border-bottom'
                                             : 'border'
                                       } w-full`}
                                    >
                                       {!FIELDS_TO_EXCLUDE_FROM_DATE_PICKER.includes(
                                          itemDetails.keyCode
                                       ) ? (
                                          <DateInputWithPicker
                                             className={` ${
                                                subIndex >= 2
                                                   ? 'empty-border-top'
                                                   : ''
                                             } ${
                                                subIndex >= 2
                                                   ? 'empty-border-top'
                                                   : ''
                                             } ${
                                                itemDetails.keyCode
                                             }-drop-down-date ${
                                                !isNaN(
                                                   new Date(
                                                      itemDetails.values
                                                   ).getTime()
                                                ) &&
                                                (itemDetails.values
                                                   ? searchCriteriaItems.categoryName ===
                                                     'Identifier'
                                                      ? 'identifier-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Fare Value'
                                                      ? 'fare-value-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Footnote'
                                                      ? 'footnote-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Rule'
                                                      ? 'rule-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Market'
                                                      ? 'market-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Brand'
                                                      ? 'brand-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Distribution'
                                                      ? 'distribution-color'
                                                      : ''
                                                   : '')
                                             }`}
                                             data-testid={`${itemDetails.keycode}-drop-down-date`}
                                             value={
                                                new Date(itemDetails.values)
                                             }
                                             defaultValue={new Date('')}
                                             minDate={new Date('01/01/2015')}
                                             showDateAsText={true}
                                             separator='/'
                                             format={'DD-MM-YYYY'}
                                             advanceByMonthAndYear={true}
                                             showTodayButton={true}
                                             title={`${itemDetails.keycode}-drop-down-date`}
                                             onChange={(value) =>
                                                handleUpdateSearchCriteriaConfig(
                                                   value,
                                                   itemDetails,
                                                   searchCriteriaItems.categoryName,
                                                   'UserInput'
                                                )
                                             }
                                          />
                                       ) : (
                                          <TextInput
                                             name={itemDetails.keycode}
                                             className={`input-text ${
                                                subIndex >= 2
                                                   ? 'empty-border-top'
                                                   : ''
                                             } ${
                                                itemDetails.values
                                                   ? searchCriteriaItems.categoryName ===
                                                     'Identifier'
                                                      ? 'identifier-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Fare Value'
                                                      ? 'fare-value-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Footnote'
                                                      ? 'footnote-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Rule'
                                                      ? 'rule-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Market'
                                                      ? 'market-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Brand'
                                                      ? 'brand-color'
                                                      : searchCriteriaItems.categoryName ===
                                                        'Distribution'
                                                      ? 'distribution-color'
                                                      : ''
                                                   : ''
                                             }`}
                                             autocomplete='off'
                                             onKeyPress={(event) =>
                                                handleKeyPress(
                                                   event,
                                                   itemDetails.keyCode
                                                )
                                             }
                                             onFocus={(event) =>
                                                handleFocus(event)
                                             }
                                             value={
                                                itemDetails.values &&
                                                itemDetails.values
                                                   .toString()
                                                   .toUpperCase()
                                             }
                                             onChange={(event) =>
                                                handleUpdateSearchCriteriaConfig(
                                                   event.target.value,
                                                   itemDetails,
                                                   searchCriteriaItems.categoryName,
                                                   searchCriteriaItems.type,
                                                   'input',
                                                   event
                                                )
                                             }
                                          />
                                       )}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        )
                     );
                  }
               )
            ) : searchCriteriaItems.type === 'RadioButtons' &&
              searchCriteriaItems.screen.includes(currentScreen) ? (
               <RadioButtons
                  radioButtonsConfig={{
                     radioButtonName: searchCriteriaItems.categoryName,
                     radioButtons: getRadioButtonData(
                        searchCriteriaItems.categoryDetails
                     ),
                     value: getSelectedRadioButtonValue(
                        searchCriteriaItems.categoryDetails
                     ),
                     onChangeHandler: (_, value) => {
                        handleRadioButtonChange(
                           value,
                           searchCriteriaItems.categoryName,
                           currentScreen
                        );
                     },
                     radioButtonClassName:
                        'spark-pad-r-2 spark-mar-b-0 default-font-family',
                     radioButtonGroupClassName:
                        'search-criteria-justify-between',
                  }}
               />
            ) : (
               ''
            )}
         </div>
      );
   };

   return (
      <div className='search-criteria-parent-root' key={key}>
         <div className='search-criteria-root search-criteria-parent-root-height'>
            <div className='search-criteria-root-content'>
               <div className='row search-criteria-title search-criteria-title-bg-color'>
                  <div
                     className='spark-bold spark-pad-t-.5 spark-pad-b-.5 spark-pad-l-.5 default-font-family'
                     data-testid='search-title-id'
                  >
                     SEARCH CRITERIA
                  </div>
               </div>
               <div className='spark-pad-b-1 spark-pad-0 spark-pad-0 last-accordion-bottom-border'>
                  <Accordion
                     activeDrawerIds={activeDrawerIds}
                     onChange={(event, activeDrawerIds) =>
                        setActiveDrawerIds(activeDrawerIds)
                     }
                  >
                     {searchCriteriaConfig.length > 0 &&
                        searchCriteriaConfig.map(
                           (searchCriteriaItems, index) => {
                              return (
                                 searchCriteriaItems.screen.includes(
                                    currentScreen
                                 ) &&
                                 (currentScreen === 'Rules' &&
                                 !NON_ACCORDION_CATEGORY.includes(
                                    searchCriteriaItems.categoryName
                                 ) ? (
                                    <Drawer
                                       id={`drawer-${index}`}
                                       className={'add-bottom-right-border'}
                                       title={searchCriteriaItems.categoryName}
                                       headingLevel='h3'
                                    >
                                       {renderSearchCriteriaFields(
                                          searchCriteriaItems
                                       )}
                                    </Drawer>
                                 ) : (
                                    <>
                                       <div className='spark-align-items-center spark-flex'>
                                          <div
                                             className='spark-bold default-font-family default-category-title spark-pad-t-.5'
                                             data-testid={`${searchCriteriaItems.categoryName}-id`}
                                          >
                                             {searchCriteriaItems.categoryName}
                                          </div>
                                       </div>
                                       {renderSearchCriteriaFields(
                                          searchCriteriaItems
                                       )}
                                    </>
                                 ))
                              );
                           }
                        )}
                  </Accordion>
               </div>
            </div>
         </div>
         <div
            className={`row search-criteria-footer spark-mar-t-.5 spark-mar-b-.5 ${
               currentScreen !== 'Distribution' && 'spark-pad-r-2'
            }`}
         >
            {searchCriteriaFooterConfiguration.map((footerItem, key, data) => {
               return (
                  <div
                     className='col-md-2 col-lg-2 spark-pad-0 button-space'
                     key={key}
                  >
                     {footerItem.key !== 'Link' && (
                        <Button
                           className={`${
                              key === 0
                                 ? 'left-border'
                                 : key === data.length - 1
                                 ? 'right-border'
                                 : 'default-no-border'
                           } ${
                              footerItem.value !== 'SEARCH'
                                 ? 'spark-btn-group-secondary'
                                 : 'spark-btn-group-primary'
                           }  search-criteria-footer-button spark-btn-over-ride`}
                           size='xs'
                           secondary={
                              footerItem.value !== 'SEARCH' ? true : false
                           }
                           disabled={false}
                           onClick={() =>
                              handleSearchCriteriaFooterEventsClick(
                                 footerItem.value
                              )
                           }
                        >
                           {footerItem.value}
                        </Button>
                     )}
                  </div>
               );
            })}
         </div>
      </div>
   );
};

SearchCriteria.propTypes = {
   getSearchCriteria: func,
   handleSearchCriteriaSearch: func,
   data: array,
   updateTariffNumber: func,
   showWarning: func,
   isTariffNumberAvailable: bool,
   currentScreen: string,
   handleStopSearchRequest: func,
   handleReferenceGroupChange: func,
   reRunQuery: bool,
};

export default SearchCriteria;
